module.exports = __webpack_public_path__ + "media/images/blog-img-01-8928ec318abfa5943bb1c2540936668f.jpg";